import React from "react";
import { CgMenuLeftAlt } from "react-icons/cg";
import { useOutletContext } from "react-router";
import DateAndTime from "./dateAndTime";
import IzunefeshLogo from "./logo";
type HeaderProps = {
  children: React.ReactNode;
};

const Header: React.FC<HeaderProps> & {
  Logo: React.FC<{ isLast?: boolean }>;
  Time: React.FC;
  Menu: React.FC<{ toggleDrawer: () => void }>;
  Title: React.FC<{ title: string }>;
} = ({ children }) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <header className="py-2 justify-between items-center flex h-20">
      {childrenArray.map((child, index) =>
        React.cloneElement(child as React.ReactElement, {
          position: index + 1,
          isLast: index + 1 === childrenArray.length,
        })
      )}
    </header>
  );
};

const Menu = ({ toggleDrawer }: { toggleDrawer: () => void }) => {
  return (
    <div className="flex flex-1 justify-end">
      <button onClick={toggleDrawer} className="hover:scale-110">
        <CgMenuLeftAlt size={30} />
      </button>
    </div>
  );
};

const Time = () => {
  const { username } = useOutletContext<{ username: string }>();
  return (
    <div className="hidden sm:flex flex-1">
      <p className="ml-4 py-2 text-lg px-4">
        {username && "היי, "}
        {username && <span className="font-bold">{username}</span>}
      </p>
      <DateAndTime />
    </div>
  );
};

const Logo = ({ isLast }: { isLast?: boolean }) => {
  return (
    <div className={`flex flex-1 ${isLast ? "justify-end" : "justify-center"}`}>
      <IzunefeshLogo />
    </div>
  );
};

const Title = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-1 text-center">
      <h1 className="font-bold text-2xl xl:text-4xl text-blue-950 text-center w-full">
        {title}
      </h1>
    </div>
  );
};

Header.Logo = Logo;
Header.Time = Time;
Header.Menu = Menu;
Header.Title = Title;

export default Header;
